import React, { Component } from 'react'

export class Form extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      isRead: false,
      isWrite: false
    }
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  handleSubmit = (event) => {
    const accessToken = {
      name: this.state.name,
      isRead: this.state.isRead,
      isWrite: this.state.isWrite
    }

    event.preventDefault()
    fetch('/api/v1/access_tokens', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.props.bearerToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(accessToken)
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          console.assert(data._error)
          return false
        }
        this.props.addNewToken(data)
      })
  }

  render () {
    return (
      <form onSubmit={this.handleSubmit}>
        <h4>Create New Access Token</h4>
        <label>
            Access token name
        </label>
        <input type='text' name='name' value={this.state.name} onChange={this.handleInputChange} />
        <label>
          <input type='checkbox' name='isRead' checked={this.state.isRead} onChange={this.handleInputChange} /> Read
        </label>
        <label>
          <input type='checkbox' name='isWrite' checked={this.state.isWrite} onChange={this.handleInputChange} /> Write
        </label>
        <input type='submit' value='Submit' className={CSS.button} />
        <button type='button' onClick={this.props.onHandleCancelCreate}>Cancel</button>
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// /app/js/components/AccessTokens/Form/index.js